import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=0df2f1d0&scoped=true&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=0df2f1d0&lang=scss&scoped=true&"
import style1 from "./WorkDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df2f1d0",
  null
  
)

export default component.exports